<template lang="pug">
    .contentpage.container
        .column.is-offset-1.is-10
            .section(v-if="sections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
                Heading(v-if="section.key === 'heading_members'" :section="section")
                Post(v-if="section.key === 'post'" :section="section")
                Members(v-if="section.key === 'members'" :section="section")
                ImageSection(v-if="section.key === 'image'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Members from '@/components/Members'
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
// import Banners from '@/components/Banners'

export default {
    name: 'MembersPage',
    components: {
        Heading,
        Post,
        Members,
        ImageSection,
        // CategoryPosts,
        // SocialWall,
        // Banners,
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading_members'
                    || section.key === 'post'
                    || section.key === 'members'
                    || section.key === 'image'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    
    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    .section.heading
        width: 100%
        margin-left: calc(-8.33333% - 0.5rem)
        margin-bottom: -1rem
        font-weight: bold
    .section.heading_members
        .container 
            text-align: left !important
            /deep/ .column
                margin-left: 0px !important
                padding-left: 0px
                h2
                    font-size: 1.5rem !important
                    margin-bottom: -1.5rem
                    margin-left: 0.75rem

    
    .section.members
        display: inline-block
        width: 50%
        +until-widescreen
            width: 100%

    .contentpage
        .section
            padding: 1rem 1.5rem
        & > .section
            padding-bottom: 0
            &:first-child
                padding-top: 4.5rem
            &:last-child
                padding-bottom: 4.5rem
            &.category-page-teaser
                display: none
        .section.heading
            text-transform: initial
</style>
